import { VOICE_CLONE_READING_TEXTS, type VoiceCloneReadingTextLang } from '@/app/constants';
import type { SiteType } from '@/app/types';

export type { VoiceCloneReadingTextLang };

/** 朗读文案语种（与界面 locale 无关，由部署站点决定） */
export function getVoiceCloneReadingTextLang(site: SiteType): VoiceCloneReadingTextLang {
  return site === 'china' ? 'zh' : 'en';
}

export function getReadingTextsForLang(lang: VoiceCloneReadingTextLang): readonly string[] {
  return VOICE_CLONE_READING_TEXTS[lang] ?? VOICE_CLONE_READING_TEXTS.en;
}

/** 进入录音流程时随机选一条口播文案 */
export function pickRandomReadingText(lang: VoiceCloneReadingTextLang): string {
  const texts = getReadingTextsForLang(lang);
  if (texts.length === 0) return '';
  const index = Math.floor(Math.random() * texts.length);
  return texts[index] ?? '';
}

/** 「换一个」：顺序循环，相邻两次不重复同一条（数组长度 > 1 时） */
export function getNextReadingText(currentText: string, lang: VoiceCloneReadingTextLang): string {
  const texts = getReadingTextsForLang(lang);
  const currentIndex = texts.indexOf(currentText);
  const nextIndex = currentIndex >= 0 ? (currentIndex + 1) % texts.length : 0;

  return texts[nextIndex] ?? '';
}
